import React from 'react';
import Select, { components } from 'react-select';

const tagOptions = [
  { value: 'autoCreated', label: 'Auto Created' },
  { value: 'opsVerified', label: 'Ops Verified' },
  { value: 'manualCreated', label: 'Manual Created' },
];
// HCL Concierge is display-only — no filter needed

const ValueContainer = ({ children, getValue, selectProps, ...props }) => {
  const selected = getValue();
  return (
    <components.ValueContainer {...props}>
      {selected.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', padding: '2px 0' }}>
          {selected.map((opt) => (
            <span
              key={opt.value}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '3px',
                backgroundColor: '#6C5DD319',
                color: '#6C5DD3',
                fontSize: '11px',
                fontWeight: '500',
                padding: '2px 6px',
                borderRadius: '8px',
                whiteSpace: 'nowrap',
              }}
            >
              {opt.value === 'autoCreated' ? 'Created' : 'Verified'}
              <span
                onMouseDown={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  const newValue = selected.filter((o) => o.value !== opt.value);
                  selectProps.onChange(newValue);
                }}
                style={{ cursor: 'pointer', lineHeight: 1, fontSize: '13px', color: '#6C5DD3' }}
              >
                ×
              </span>
            </span>
          ))}
        </div>
      ) : (
        children
      )}
    </components.ValueContainer>
  );
};

const VisionTagFilter = ({ onChange, currentFilter }) => {
  const selected = currentFilter
    ? tagOptions.filter((o) => currentFilter.includes(o.value))
    : [];

  return (
    <Select
      isMulti
      options={tagOptions}
      value={selected}
      onChange={(selectedOptions) => {
        const values = selectedOptions?.map((o) => o.value) || [];
        onChange(values.length > 0 ? values : null);
      }}
      placeholder="All"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      components={{ ValueContainer }}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: '40px',
          fontSize: '12px',
          borderRadius: '10px',
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (base, state) => ({
          ...base,
          fontSize: '12px',
          backgroundColor: state.isSelected ? '#6C5DD319' : state.isFocused ? '#f5f5f5' : '#fff',
          color: '#0F0B28',
        }),
      }}
    />
  );
};

export default VisionTagFilter;
